module.exports = __webpack_public_path__ + "static/media/sixgif.d997f508.gif";